import { BrandHeading } from '../../components/lease/BrandHeading';
import { PrimaryButton } from '../../components/lease/PrimaryButton';

export const LABELS = {
  landlord: 'Landlord',
  tenant: 'Tenant',
  address: 'Property address',
  lease_start: 'Lease start',
  lease_end: 'Lease end',
  signing_date: 'Signing date',
  monthly_rent: 'Monthly rent',
  rent_due_day: 'Rent due day',
  grace_period_days: 'Grace period (days)',
  late_fee: 'Late fee',
  deposit_amount: 'Security deposit',
  deposit_refund_deadline_days: 'Deposit refund deadline (days)',
  utilities: 'Utilities',
  pets_allowed: 'Pets allowed',
  smoking_allowed: 'Smoking allowed',
  early_termination: 'Early termination',
  renewal: 'Renewal',
};

const MONEY_FIELDS = new Set(['monthly_rent', 'late_fee', 'deposit_amount']);

export function formatValue(key, value) {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (MONEY_FIELDS.has(key) && typeof value === 'number') {
    return `$${value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }
  return String(value);
}

export function ExtractionReview({ details, onConfirm }) {
  const rows = Object.entries(details).filter(([, v]) => v !== null && v !== undefined);
  return (
    <div>
      <header className="animate-fade-in text-center">
        <BrandHeading as="h2" className="text-2xl">Does this look right?</BrandHeading>
        <p className="mt-2 text-slate-600 dark:text-slate-300">
          Confirm what we pulled from your lease before we analyze it.
        </p>
      </header>

      {rows.length === 0 ? (
        <div className="mt-6 animate-slide-in rounded-2xl bg-amber-50 p-4 text-sm text-amber-800 ring-1 ring-amber-100 dark:bg-amber-950/40 dark:text-amber-300 dark:ring-amber-900">
          We couldn't automatically read the basic details from this lease. You
          can still run the analysis, but double-check that your file is a
          text-based PDF (not a scanned image).
        </div>
      ) : (
        <dl className="mt-6 animate-slide-in divide-y divide-emerald-100 rounded-2xl bg-white/70 p-4 shadow-sm ring-1 ring-emerald-100 backdrop-blur dark:divide-slate-700 dark:bg-slate-800/60 dark:ring-slate-700">
          {rows.map(([k, v]) => (
            <div key={k} className="flex items-center justify-between gap-4 py-2 first:pt-0 last:pb-0">
              <dt className="font-semibold text-emerald-700 dark:text-emerald-400">{LABELS[k] || k}</dt>
              <dd className="text-right text-slate-700 dark:text-slate-200">{formatValue(k, v)}</dd>
            </div>
          ))}
        </dl>
      )}

      <PrimaryButton onClick={onConfirm} className="mt-6 animate-slide-in">
        Looks right — continue
      </PrimaryButton>
    </div>
  );
}
